import { Component, inject, Input, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { SegmentGroupType } from "@arch/_shared/types/company.types";
import { BenchmarkingEntity } from "@arch/domain/entity/benchmarking.entity";

@Component({
    selector: "app-benchmark-data-source-info-dialog",
    imports: [SharedMaterialModule, SharedDsnModule],
    templateUrl: "./benchmark-data-source-info-dialog.component.html",
    styleUrl: "./benchmark-data-source-info-dialog.component.scss"
})
export class BenchmarkDataSourceInfoDialogComponent {
    readonly dialogRef = inject(
        MatDialogRef<BenchmarkDataSourceInfoDialogComponent>
    );
}
